import { common } from '../../common';
import { IOHelper } from '../../IOHelper';
import { createSerializeWire } from '../Serializable';
const SIZE = IOHelper.sizeOfUInt256 + IOHelper.sizeOfUInt16LE;
export class InputModel {
    constructor({ hash, index }) {
        this.size = SIZE;
        this.serializeWire = createSerializeWire(this.serializeWireBase.bind(this));
        this.hash = hash;
        this.hashHex = common.uInt256ToHex(hash);
        this.index = index;
    }
    serializeWireBase(writer) {
        writer.writeUInt256(this.hash);
        writer.writeUInt16LE(this.index);
    }
}
InputModel.size = SIZE;

//# sourceMappingURL=InputModel.js.map
